module.exports = __webpack_public_path__ + "static/media/news-17.c6117763.jpg";